import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import KenButton from '../../global_components/KenButton';
import { Typography } from '@material-ui/core';
import { RiCheckLine } from 'react-icons/ri';

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
}));

export default function KenPopover(props) {
  const classes = useStyles();
  const {
    anchorEl,
    handleClose,
    id,
    open,
    negativeButtonText,
    positiveButtonText,
    negativeButtonProps,
    positiveButtonProps,
    negativeButtonClick,
    positiveButtonClick,
    positiveButtonLabelProps,
    negativeButtonLabelProps,
    hidePositiveButton = true,
    hideNegativeButton = true,
  } = props;
  return (
    <div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        disableScrollLock={true}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        classes={{ root: classes.root, paper: classes.paper }}
        {...props}
        className="pop-mg"
      >
        {props.children}
        <div className="custom-button-section">
          {!hideNegativeButton && (
            <KenButton
              {...negativeButtonProps}
              onClick={negativeButtonClick}
              // onClick={() => {
              //   //   console.log('KenDialog: Negative Button Clikc');
              //   onNegativeButtonClick();
              // }}
              color="primary"
              variant="secondary"
              label={
                <Typography
                  {...negativeButtonLabelProps}
                  className={classes.btnLabel}
                >
                  {negativeButtonText || 'Cancel'}
                </Typography>
              }
            />
          )}
          {!hidePositiveButton && (
            <KenButton
              className={classes.btnLabel}
              onClick={positiveButtonClick}
              color="primary"
              variant="primary"
              startIcon={<RiCheckLine />}
              {...positiveButtonProps}
              label={
                <Typography
                  {...positiveButtonLabelProps}
                  className={classes.btnLabel}
                >
                  {' '}
                  {positiveButtonText || 'Ok'}
                </Typography>
              }
            />
          )}
        </div>
      </Popover>
    </div>
  );
}
